import axios from "../config";

export const getCompanySettings = () => {
  return axios.get("/company");
};
